import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=6a0eac3c"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0eac3c')) {
      api.createRecord('6a0eac3c', component.options)
    } else {
      api.reload('6a0eac3c', component.options)
    }
    module.hot.accept("./chat.vue?vue&type=template&id=6a0eac3c", function () {
      api.rerender('6a0eac3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/conversation-list/chat.vue"
export default component.exports